import { Button, CircularProgress } from '@mui/material';
import { AlertType, appendAlertItem } from '@pruforce/common-adminweb-sdk';
import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { downloadBdmBatchFileTemplateFile, uploadBdmBatchFile } from 'src/app/modules/OpmPd/network/opm-pd-bdm';
import { useBatchFileListContext } from '../../BatchFileList.context';

const DownloadTemplateButton = () => {
  const [isDownloading, setIsDownloading] = React.useState(false);

  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });

  const dispatch = useDispatch();

  const downloadTemplate = async () => {
    setIsDownloading(true);
    try {
      const blob = await downloadBdmBatchFileTemplateFile(undefined, dispatch);
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'batch-file-template.xlsx';
      link.click();
      URL.revokeObjectURL(url);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Button
      variant="contained"
      color="secondary"
      onClick={downloadTemplate}
      disabled={isDownloading}
      startIcon={isDownloading ? <CircularProgress size={16} color="inherit" /> : undefined}
    >
      {Translation('opm_pd.downloadTemplate')}
    </Button>
  );
};

const UploadButton = () => {
  const [isUploading, setIsUploading] = React.useState(false);
  const fileInputRef = React.useRef<HTMLInputElement>(null);
  const dispatch = useDispatch();
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const { refreshData } = useBatchFileListContext();

  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setIsUploading(true);
    try {
      await uploadBdmBatchFile({ file }, dispatch);
      dispatch(
        appendAlertItem([
          {
            severity: AlertType.SUCCESS,
            title: Translation('opm_pd.success'),
            content: Translation('opm_pd.uploadFileSuccess'),
          },
        ]),
      );
      refreshData();
    } finally {
      setIsUploading(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  return (
    <>
      <input ref={fileInputRef} type="file" accept=".xlsx,.xls,.csv" hidden onChange={handleUpload} />
      <Button
        variant="contained"
        color="secondary"
        onClick={() => fileInputRef.current?.click()}
        disabled={isUploading}
        startIcon={isUploading ? <CircularProgress size={16} color="inherit" /> : undefined}
      >
        {Translation('opm_pd.uploadFile')}
      </Button>
    </>
  );
};

const UploadFile = () => {
  return (
    <>
      <DownloadTemplateButton />
      <UploadButton />
    </>
  );
};

export default UploadFile;
